import Box from '@mui/material/Box';
import { observer } from 'mobx-react';
import PmgImage from "./image/Pmg_big.png";
import CloverleafImage from "./image/Cloverleaf.png";
import Blind from './image/blind.png';
import CagImage from './image/cag_big.png';
import GolfImage from './image/GP_big.jpg';

import { useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useStore } from "../../state/MobxContext";
import { Grid } from '@mui/material';
import Completion from './image/completion.png';
import { useEffect } from 'react';
// import { debug } from '../../utils/UtilConsole';
import { StringFormat } from '../../utils/SessionService';



function MissionPmgBar() {

    const { loginStore } = useStore();
    const { MissionStore } = useStore();
    const isMobile = useMediaQuery("(max-width: 600px)");
    const isSm = useMediaQuery("(max-width: 900px)");




    const WhiteTextTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '0.6rem',
                color: "#FFFFFF",
                fontWeight: 'bold'
            }
            :
            isSm ?
                {
                    fontSize: '1rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {
                    fontSize: '2rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
    })(Typography);


    const WhiteMissionTextTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '2.5rem',
                color: "#FFFFFF",
                fontWeight: 'bold'
            }
            :
            isSm ?
                {
                    fontSize: '6rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {
                    fontSize: '9rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
    })(Typography);


    const WhiteCompletionTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '0.5rem',
                color: "#FFFFFF",
                fontWeight: 'bold',
            }
            :
            isSm ?
                {
                    fontSize: '1rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {
                    fontSize: '1.5rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold',
                }
    })(Typography);


    const WhiteMissiomTextTypography = withStyles({
        root: isMobile ?
            {
                fontSize: '0.5rem',
                color: "#FFFFFF",
                fontWeight: 'bold',
            }
            :
            isSm ?
                {
                    fontSize: '1rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold'
                }
                :
                {
                    fontSize: '1.5rem',
                    color: "#FFFFFF",
                    fontWeight: 'bold',
                }
    })(Typography);

    const member_no = loginStore?.loginState?.member_no;
    const MissonPmgButton = MissionStore?.MissionPmgButton;
    const MissonCagButton = MissionStore?.MissionCagButton;
    const MissonGolfButton = MissionStore?.MissionGolfButton;

    // console.log(MissonGolfButton);

    let RemainHoursTime = MissionStore?.RemainHoursTime;
    let RemainMinsTime = MissionStore?.RemainMinsTime;
    let RemainSecsTime = MissionStore?.RemainSecsTime;
    let PmgRewardCount = MissionStore?.MissionPmgState?.reward_count;
    let CagRewardCount = MissionStore?.MissionCagState?.reward_count;
    let PmgConditionCount = MissionStore?.MissionPmgState?.condition_count;
    // let PmgplayCount = MissionStore?.MissionPmgState?.play_count;
    let PmgCount = MissionStore.PmgMissionCount;
    let CagConditionCount = MissionStore?.MissionCagState?.condition_count;
    // let CagplayCount = MissionStore?.MissionCagState?.play_count;
    let CagCount = MissionStore.CagMissionCount;

    let GolfCount = MissionStore.GolfMissionCount;// 처리해야함
    let GolfConditionCount = MissionStore?.MissionGolfState?.condition_count;// 처리해야함
    let GolfRewardCount = MissionStore?.MissionGolfState?.reward_count;






    useEffect(() => {//미션카운트
        const member_no = loginStore?.loginState?.member_no;
        const countdown = setInterval(() => {
            if (member_no !== undefined || member_no !== null || member_no !== "") {
                MissionStore.getUserMissionCount();
            }
            else {
                clearInterval(countdown);
            }
        }, 300000);
        return () => clearInterval(countdown);
        // eslint-disable-next-line
    }, [member_no]);



    // const testData = MissionStore.PmgMissionLevelState;

    // console.log("HonePage", testData);
    let Timer = RemainHoursTime !== undefined || RemainHoursTime !== null ? RemainHoursTime + ":" + RemainMinsTime + ":" + RemainSecsTime : "00:00:00";

    // {
    //     RemainHoursTime != undefined || RemainHoursTime != null ? RemainHoursTime + ":" + RemainMinsTime + ":" + RemainSecsTime : "00:00:00"
    // } 후 도전 가능
    let Guide_clover_allPage_06 = loginStore?.Guide_clover_allPage_06; //회
    let Guide_clover_page_MissionPmgBar_01 = loginStore?.Guide_clover_page_MissionPmgBar_01; //회
    let Guide_clover_page_MissionPmgBar_02 = loginStore?.Guide_clover_page_MissionPmgBar_02; //클릭해서 리워드를 /n 받으세요.
    let Guide_clover_page_MissionPmgBar_03 = loginStore?.Guide_clover_page_MissionPmgBar_03; //보상을 받으셨습니다
    let Guide_clover_page_MissionPmgBar_04 = StringFormat(loginStore?.Guide_clover_page_MissionPmgBar_04, Timer); //후 도전 가능




    return (
        <div>
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' >
                {MissonPmgButton === 0 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: 'auto', p: 1, marginBottom: "-8px" }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%' }} onClick={(e) => { MissionStore.setMissionCheck({ game: "Pmg", count: PmgCount === undefined || PmgCount === null || PmgCount === "" ? 20 : PmgCount }) }}  >
                        <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'   >
                            <img id="Mission_One" style={{ width: "90%", height: "auto", margin: 0, padding: 0, marginBottom: '10px' }} src={PmgImage} alt="PmgImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0, marginBottom: '10px' }} src={Blind} alt="Blind" />
                                <Box style={{ position: "absolute", width: '40%', height: '100%', margin: 0, padding: 0, display: "grid" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' >
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} maxHeight="25%"  >
                                            <WhiteTextTypography>{Guide_clover_page_MissionPmgBar_01}</WhiteTextTypography>
                                        </Grid>
                                        <Grid display='flex' justifyContent='center' alignItems='center' maxHeight="135px" minHeight='20px' height={isMobile ? '40%' : '50%'} >
                                            <>
                                                <WhiteMissionTextTypography>
                                                    {
                                                        PmgConditionCount != undefined || PmgConditionCount != null ? PmgCount : "30"
                                                    }
                                                </WhiteMissionTextTypography>
                                                <WhiteTextTypography style={{ marginBottom: "-20%" }}>{Guide_clover_allPage_06}</WhiteTextTypography>
                                            </>
                                        </Grid>
                                        <Grid display='flex' justifyContent='center' maxHeight="67.5px" height='25%' alignItems='center' >
                                            <>
                                                <img id="CloverleafImage" style={{ width: "12%", height: "auto", margin: 0, padding: 0 }} src={CloverleafImage} alt="CloverleafImage" />
                                                <WhiteTextTypography>
                                                    {
                                                        PmgRewardCount != undefined || PmgRewardCount != null ? PmgRewardCount : "3000"
                                                    }
                                                </WhiteTextTypography>
                                            </>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid >
                        </Grid >
                    </Box>
                }
                {MissonPmgButton === 1 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: 'auto', p: 1, marginBottom: "-8px" }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%' }} onClick={(e) => { MissionStore.setPmgClearTodayMission("Pmg") }} >
                        <Grid container item whiteSpace="pre-wrap" style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'   >
                            <img id="Mission_One" style={{ width: "90%", height: "auto", margin: 0, padding: 0, marginBottom: '10px' }} src={PmgImage} alt="PmgImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0, marginBottom: '10px' }} src={Blind} alt="Blind" />
                                <Box style={{ position: "absolute", width: '40%', height: '49%', maxHeight: '270px', minHeight: '60px', margin: 0, padding: 0, display: "grid", top: isMobile ? '-10%' : "15%" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' alignItems='center' justifyContent='center'  >
                                        <Grid maxHeight="135px" minHeight='25px' height='50%' >
                                            <img id="Completion" style={{ width: "100%", height: "auto", margin: 0, padding: 0 }} src={Completion} alt="Completion" />
                                            <Grid container direction='column' alignContent='center' justifyContent='center'>
                                                <WhiteCompletionTypography>{Guide_clover_page_MissionPmgBar_02}</WhiteCompletionTypography>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid >
                        </Grid >
                    </Box>
                }
                {MissonPmgButton === 2 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: 'auto', p: 1, marginBottom: "-8px" }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%' }} onClick={(e) => { MissionStore.setMissionCheck({ game: "Pmg", count: PmgCount, clear: true }) }} >
                        <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'   >
                            <img id="Mission_One" style={{ width: "90%", height: "auto", margin: 0, padding: 0, marginBottom: '10px' }} src={PmgImage} alt="PmgImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0, marginBottom: '10px' }} src={Blind} alt="Blind" />
                                <Box style={{ position: "absolute", width: '40%', height: '49%', maxHeight: '270px', minHeight: '60px', margin: 0, padding: 0, display: "grid", top: isMobile ? '-15%' : "15%" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' alignItems='center' justifyContent='center' >
                                        <Grid maxHeight="135px" minHeight='25px' height='50%' >
                                            <img id="Completion" style={{ width: "100%", height: "auto", margin: 0, padding: 0 }} src={Completion} alt="Completion" />
                                            <Grid container direction='column' alignItems='center' justifyContent='center'>
                                                <WhiteMissiomTextTypography>{Guide_clover_page_MissionPmgBar_03}</WhiteMissiomTextTypography>
                                                <WhiteMissiomTextTypography>{Guide_clover_page_MissionPmgBar_04}</WhiteMissiomTextTypography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid >
                        </Grid >
                    </Box>
                }

                {MissonCagButton === 0 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: '100%', p: 1, marginTop: '-8px' }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%', marginTop: '-15px' }} onClick={(e) => { MissionStore.setMissionCheck({ game: "Cag", Count: CagCount === undefined || CagCount === null || CagCount === "" ? 20 : CagCount }) }} >
                        <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'   >
                            <img id="Mission_Two" style={{ width: "90%", height: "auto", margin: 0, padding: 0, }} src={CagImage} alt="PmgImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                                <Box style={{ position: "absolute", width: '40%', height: '100%', margin: 0, padding: 0, display: "grid" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' >
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} maxHeight="25%"  >
                                            <WhiteTextTypography>play</WhiteTextTypography>
                                        </Grid>
                                        <Grid display='flex' justifyContent='center' alignItems='center' maxHeight="135px" minHeight='20px' height={isMobile ? '40%' : '50%'} >
                                            <>
                                                <WhiteMissionTextTypography>
                                                    {
                                                        CagConditionCount != undefined || CagConditionCount != null ? CagCount : "30"
                                                    }
                                                </WhiteMissionTextTypography>
                                                <WhiteTextTypography style={{ marginBottom: "-20%" }}>{Guide_clover_allPage_06}</WhiteTextTypography>
                                            </>
                                        </Grid>
                                        <Grid display='flex' justifyContent='center' maxHeight="67.5px" height='25%' alignItems='center' >
                                            <>
                                                <img id="CloverleafImage" style={{ width: "12%", height: "auto", margin: 0, padding: 0 }} src={CloverleafImage} alt="CloverleafImage" />
                                                <WhiteTextTypography>
                                                    {
                                                        CagRewardCount != undefined || CagRewardCount != null ? CagRewardCount : "3000"
                                                    }
                                                </WhiteTextTypography>
                                            </>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Grid >
                        </Grid >
                    </Box>
                }
                {MissonCagButton === 1 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: '100%', p: 1, marginTop: '-8px' }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%', marginTop: '-15px' }} onClick={(e) => { MissionStore.setCagClearTodayMission("Cag") }} >
                        <Grid container item whiteSpace="pre-wrap" style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'  >
                            <img id="Mission_Two" style={{ width: "90%", height: "auto", margin: 0, padding: 0, }} src={CagImage} alt="PmgImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                                <Box style={{ position: "absolute", width: '40%', height: '49%', maxHeight: '270px', minHeight: '60px', margin: 0, padding: 0, display: "grid", top: isMobile ? '-10%' : "15%" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' alignItems='center' justifyContent='center'  >
                                        <Grid maxHeight="135px" minHeight='25px' height='50%' >
                                            <img id="Completion" style={{ width: "100%", height: "auto", margin: 0, padding: 0 }} src={Completion} alt="Completion" />
                                            <Grid container direction='column' alignItems='center' justifyContent='center'>
                                                {/* <WhiteCompletionTypography>클릭해서 리워드를</WhiteCompletionTypography>
                                                <WhiteCompletionTypography>받으세요.</WhiteCompletionTypography> */}
                                                <WhiteCompletionTypography>{Guide_clover_page_MissionPmgBar_02}</WhiteCompletionTypography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Grid >
                        </Grid >
                    </Box>
                }
                {MissonCagButton === 2 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: '100%', p: 1, marginTop: '-8px' }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%', marginTop: '-15px' }} onClick={(e) => { MissionStore.setMissionCheck({ game: "Cag", Count: CagCount, clear: true }) }} >
                        <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' >
                            <img id="Mission_Two" style={{ width: "90%", height: "auto", margin: 0, padding: 0, }} src={CagImage} alt="PmgImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                                <Box style={{ position: "absolute", width: '40%', height: '49%', maxHeight: '270px', minHeight: '60px', margin: 0, padding: 0, display: "grid", top: isMobile ? '-15%' : "15%" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' alignItems='center' justifyContent='center' >
                                        <Grid maxHeight="135px" minHeight='25px' height='50%' >
                                            <img id="Completion" style={{ width: "100%", height: "auto", margin: 0, padding: 0 }} src={Completion} alt="Completion" />
                                            <Grid container direction='column' alignItems='center' justifyContent='center'>
                                                <WhiteMissiomTextTypography>{Guide_clover_page_MissionPmgBar_03}</WhiteMissiomTextTypography>
                                                <WhiteMissiomTextTypography>{Guide_clover_page_MissionPmgBar_04}</WhiteMissiomTextTypography>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid >
                        </Grid >
                    </Box>
                }

                {MissonGolfButton === 0 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: '100%', p: 1, marginTop: '-8px' }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%', marginTop: '-5px' }} onClick={(e) => { MissionStore.setMissionCheck({ game: "golf", Count: GolfCount == undefined || GolfCount == null || GolfCount == "" ? 10 : GolfCount }) }} >
                        <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'   >
                            <img id="Mission_Two" style={{ width: "90%", height: "auto", margin: 0, padding: 0, }} src={GolfImage} alt="GolfImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                                <Box style={{ position: "absolute", width: '40%', height: '100%', margin: 0, padding: 0, display: "grid" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' >
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} maxHeight="25%"  >
                                            <WhiteTextTypography>play</WhiteTextTypography>
                                        </Grid>
                                        <Grid display='flex' justifyContent='center' alignItems='center' maxHeight="135px" minHeight='20px' height={isMobile ? '40%' : '50%'} >
                                            <>
                                                <WhiteMissionTextTypography>
                                                    {
                                                        GolfConditionCount != undefined || GolfConditionCount != null ? GolfCount : "30"
                                                    }
                                                </WhiteMissionTextTypography>
                                                <WhiteTextTypography style={{ marginBottom: "-20%" }}>{Guide_clover_allPage_06}</WhiteTextTypography>
                                            </>
                                        </Grid>
                                        <Grid display='flex' justifyContent='center' maxHeight="67.5px" height='25%' alignItems='center' >
                                            <>
                                                <img id="CloverleafImage" style={{ width: "12%", height: "auto", margin: 0, padding: 0 }} src={CloverleafImage} alt="CloverleafImage" />
                                                <WhiteTextTypography>
                                                    {
                                                        GolfRewardCount != undefined || GolfRewardCount != null ? GolfRewardCount : "3000"
                                                    }
                                                </WhiteTextTypography>
                                            </>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Grid >
                        </Grid >
                    </Box>
                }
                {MissonGolfButton === 1 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: '100%', p: 1, marginTop: '-8px' }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%', marginTop: '-5px' }} onClick={(e) => { MissionStore.setGolfClearTodayMission("golf") }} >
                        <Grid container item whiteSpace="pre-wrap" style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'  >
                            <img id="Mission_Two" style={{ width: "90%", height: "auto", margin: 0, padding: 0, }} src={GolfImage} alt="GolfImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                                <Box style={{ position: "absolute", width: '40%', height: '49%', maxHeight: '270px', minHeight: '60px', margin: 0, padding: 0, display: "grid", top: isMobile ? '-10%' : "15%" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' alignItems='center' justifyContent='center'  >
                                        <Grid maxHeight="135px" minHeight='25px' height='50%' >
                                            <img id="Completion" style={{ width: "100%", height: "auto", margin: 0, padding: 0 }} src={Completion} alt="Completion" />
                                            <Grid container direction='column' alignItems='center' justifyContent='center'>
                                                <WhiteCompletionTypography>{Guide_clover_page_MissionPmgBar_02}</WhiteCompletionTypography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Grid >
                        </Grid >
                    </Box>
                }
                {MissonGolfButton === 2 &&
                    <Box sx={isMobile ? { bgcolor: 'black', maxWidth: '100%', mx: 'auto', height: '100%', p: 1, marginTop: '-8px' }
                        : { bgcolor: 'black', maxWidth: '100%', mx: 'auto', p: 1, height: '100%', width: '100%', marginTop: '-5px' }} onClick={(e) => { MissionStore.setMissionCheck({ game: "golf", Count: GolfCount, clear: true }) }} >
                        <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' >
                            <img id="Mission_Two" style={{ width: "90%", height: "auto", margin: 0, padding: 0, }} src={GolfImage} alt="GolfImage" />
                            <Grid container item style={{ position: "absolute", marginLeft: '-10%' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                                <img id="Blind" style={{ width: "57%", height: "auto", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                                <Box style={{ position: "absolute", width: '40%', height: '49%', maxHeight: '270px', minHeight: '60px', margin: 0, padding: 0, display: "grid", top: isMobile ? '-15%' : "15%" }} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' maxHeight="270px" minHeight='60px' alignItems='center' justifyContent='center' >
                                        <Grid maxHeight="135px" minHeight='25px' height='50%' >
                                            <img id="Completion" style={{ width: "100%", height: "auto", margin: 0, padding: 0 }} src={Completion} alt="Completion" />
                                            <Grid container direction='column' alignItems='center' justifyContent='center'>
                                                <WhiteMissiomTextTypography>{Guide_clover_page_MissionPmgBar_03}</WhiteMissiomTextTypography>
                                                <WhiteMissiomTextTypography>{Guide_clover_page_MissionPmgBar_04}</WhiteMissiomTextTypography>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid >
                        </Grid >
                    </Box>
                }

            </Grid>

        </div>
    );
};


export default observer(MissionPmgBar);